module.exports = __webpack_public_path__ + "static/img/friend01.020b87d3.png";